import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getSearchApiUrl } from './util';
import { useApi } from '../../../ApiClient';

export const useDeletePastSearch = (pastSearchBaseUrl: string) => {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['deletePastSearch'],
    mutationFn: async (searchText: string) =>
      apiClient?.delete(
        `${getSearchApiUrl(pastSearchBaseUrl)}?term=${encodeURIComponent(
          searchText
        )}`
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getPastSearch'] });
    },
  });
};
